import React from "react";
import RandomFloating from "../../common/components/RandomFloating";
const SideAvatars = ({ src = "", className = "", alt = "" }) => {
  return (
    <RandomFloating
      movementSpace={5}
      transitionSpeed={1}
      positionResetIn={1000}
      className={className}>
      <img src={src} alt={alt} className=" object-cover" />
    </RandomFloating>
  );
};

export default SideAvatars;
